
import { Component, Vue } from "vue-property-decorator";
const Config = (require("../public/setting") as any).Config;
@Component({})
export default class App extends Vue {
  private created() {
    let state = sessionStorage.getItem("state");
    if (state) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(state))
      );
      sessionStorage.removeItem("state");
    }
  }
  private mounted() {
    // 保证页面刷新时store的值不丢失
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    this.$store.commit("updateSystemInfo", Config);
    // 修改项目名称
    document.title = Config.PROJECT_NAME;
    // 修改项目 icon
    let link: any = document.querySelector("link[rel='icon']");
    if (link) {
      link.href = "new/path/to/your/favicon.ico";
    } else {
      var newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = Config.ICO;
      newLink.type = "image/x-icon";
      document.head.appendChild(newLink);
    }
  }
  beforeDestroy() {
    window.removeEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    // window.removeEventListener("popstate");
  }
}
